import {
  CreateRequest,
  getStaticPropsFor,
} from '@/components/AdCreate/CreateRequest';

export default CreateRequest;

export const getStaticProps = getStaticPropsFor('request');
